import { useUpdateWorkspaceProfileMutation } from '@sketch/gql-types'
import { BannerSection } from 'components/BannerSection'
import { Button } from '@sketch/components'
import { useToast } from 'containers/ToastManager'
import React from 'react'

export interface HideProfileSectionProps {
  identifier: string
}
export const HideProfileSection = (props: HideProfileSectionProps) => {
  const { identifier } = props
  const { showToast } = useToast()

  const [publishProfile, { loading }] = useUpdateWorkspaceProfileMutation({
    onCompleted: () => {
      showToast('Public profile is now hidden')
    },
    onError: message => showToast(message, 'negative'),
    variables: {
      input: {
        identifier,
        isPublic: false,
      },
    },
  })

  return (
    <BannerSection
      type="positive"
      button={
        <Button
          size="40"
          variant="primary-untinted"
          loading={loading}
          disabled={loading}
          onClick={() => publishProfile()}
        >
          Hide Profile
        </Button>
      }
    >
      Your public profile was successfully published.
    </BannerSection>
  )
}
